{
    "roadmap": {
        "common": {
            "openAll": "Deschide toate",
            "closeAll": "Închide toate",
            "openorCloseTitle": "Deschide/Închide toate acordioanele"
        },
        "nextGen": {
            "nextGenTitle": "NextGen IT",
            "nextGenDesc": "Ce este NextGen IT: Aduce automatizarea IT utilizatorului final și rezolvă problema mai rapid.",
            "acc1Title": "În producție",
            "prodItem1": "Integrare articol KB: 300+ articole KB care permit auto-rezolvarea IT",
            "prodItem2": "Soluție de auto-vindecare: Mai mult de 18 scripturi la distanță sunt disponibile pentru a rezolva problema.",
            "prodItem3": "Crearea incidentului: Asigură o rezolvare precisă și rapidă prin înregistrarea automată a incidentelor.",
            "prodItem4": "Chat cu agent uman (agent uman): MyHelp permite utilizatorilor să discute cu un agent uman din Asistentul AI",
            "acc2Title": "În dezvoltare",
            "devItem1": "Programare apel înapoi (Feb - 2026): Programează un apel de suport IT la un moment care se potrivește cu disponibilitatea ta",
            "devItem2": "Routare inteligentă (Feb - 2026): Direcționează tichetele către echipa de rezolvare corectă pentru suport mai rapid",
            "acc3Title": "Backlog",
            "backItem1": "Agent de depanare PKI: Integrarea MyHelp cu agentul de depanare PKI pentru a aborda problemele legate de certificate",
            "backItem2": "Programare întâlniri la Centrul de Walk-in direct prin MyHelp"
        },
        "corporate": {
            "title": "Corporate",
            "desc": "Corporate este responsabil pentru gestionarea aplicațiilor corporative ale întreprinderii, platformelor HR, care susțin funcțiile de muncă și afaceri.",
            "acc1Title": "În producție",
            "prodItem1": "Aplicații bazate pe BU: 90+ aplicații cu personalizare bazată pe BU",
            "prodItem2": "Fixare aplicații personalizate: Utilizatorii își pot personaliza tabloul de bord MyHelp prin fixarea aplicațiilor personalizate",
            "prodItem3": "Întrebări despre locul de muncă: 100+ întrebări despre locul de muncă (birou, parcare, clădiri)",
            "prodItem4": "Rezervare sală de întâlniri cu asistent AI: Rezervare rapidă și simplificată a sălii de întâlniri cu integrarea Gingco",
            "prodItem5": "Întrebări HR: MyHelp răspunde la top 50 întrebări HR",
            "prodItem6": "Căutare persoane: Utilizatorii pot căuta colegii E.ON prin MyHelp",
            "acc2Title": "În dezvoltare",
            "devItem1": "Integrarea aplicațiilor bazată pe lansarea unității de afaceri.",
            "devItem2": "Asistent AI pentru sala de întâlniri",
            "acc3Title": "În Backlog",
            "backItem1": "Adăugarea aplicațiilor din asistentul AI și filele personalizate: Adăugarea instantanee a aplicațiilor prin opțiunile sugerate ale Asistentului MyHelp"
        },
        "myGenius": {
            "title": "MyGenius",
            "desc": "Această integrare te ajută să localizezi cursuri și instruiri relevante.",
            "acc1Title": "În producție",
            "prodItem1": "Căutare instruiri și cursuri: Găsește instruiri și cursuri relevante folosind MyHelp",
            "acc2Title": "În dezvoltare",
            "acc3Title": "În Backlog",
            "backItem1": "Învățare personalizată: Recomandări de instruire personalizate bazate pe eligibilitatea unității de afaceri."
        },
        "myItOrder": {
            "title": "MyIT order",
            "desc": "Această integrare te ajută să găsești articole și cataloage relevante de comandă IT.",
            "acc1Title": "În producție",
            "prodItem1": "Căutare rapidă în catalogul de comenzi IT: Caută rapid și comandă IT-ul tău din MyHelp",
            "prodItem2": "Activarea și revocarea accesului la software: Activează sau revocă accesul la software navigând din MyHelp.",
            "acc2Title": "În dezvoltare",
            "devItem1": "Prezentare generală a costurilor activelor IT: MyHelp va afișa o prezentare generală a costurilor activelor IT",
            "acc3Title": "În Backlog",
            "backItem1": "Aprobarea centrală a articolelor comandate"
        },
        "compass": {
            "title": "Compass",
            "desc": "Această integrare te va ajuta să găsești comunitatea, informațiile de știri și anunțurile care sunt partajate pe intranet.",
            "acc1Title": "În producție",
            "prodItem1": "Va fi lansat până pe 28 februarie 2026",
            "acc2Title": "În dezvoltare",
            "devItem1": "Căutare Compass (Feb – 2026): Utilizatorii E.ON vor putea căuta datele comunității lor în MyHelp E.ON Search",
            "devItem2": "Asistent AI MyHelp-Compass (în curs de desfășurare) (Feb – 2026): Permite utilizatorilor E.ON să acceseze datele comunității prin Asistentul AI MyHelp",
            "acc3Title": "În Backlog"
        },
        "chatProjectData": {
            "title": "Chat cu datele proiectului tău",
            "desc": "Această integrare îți permite să integrezi datele proiectului tău din confluence, sharepoint etc.",
            "acc1Title": "În producție",
            "prodItem1": "Proiectele Confluence One Billing și DSODP sunt integrate",
            "prodItem2": "Site-uri SharePoint – site-ul proiectului DSODP este integrat",
            "acc2Title": "În dezvoltare",
            "devItem1": "Lucrul la integrarea datelor proiectului Nautilus este în curs de desfășurare.",
            "acc3Title": "În Backlog"
        },
        "personalization": {
            "title": "Personalizare",
            "acc1Title": "În producție",
            "prodItem1": "Multi-lingual: suportă 4 limbi (Engleză, Deutsch, Svenska, Română)",
            "prodItem2": "Multi-temă: permite fiecărei unități de afaceri sau regiuni să folosească propria marcă, îmbunătățind familiaritatea și adoptarea.",
            "prodItem3": "5 limbi noi suplimentare sub profil beta (Čeština, Italiano, Magyar, Nederlands și Polski)",
            "acc2Title": "În dezvoltare",
            "devItem1": "Sursă de date specifică: (15 februarie – 2026): oferă răspunsuri mai țintite și conștiente de context prin extragerea informațiilor din sursele de date selectate de utilizator.",
            "acc3Title": "În Backlog"
        },
        "technicalEnablement": {
            "title": "Facilitare tehnică",
            "acc1Title": "În producție",
            "prodItem1": "Securitate și observabilitate asigură protecția datelor la nivel de întreprindere, conformitatea și performanța, și de asemenea, permite desfășurarea operațiunilor în mod sigur, fiabil și fără probleme",
            "prodItem2": "Tablouri de bord KPI și adoptare (Power BI)<br /> Oferă vizibilitate clară asupra utilizării, realizării valorii și impactului asupra afacerii prin tablouri de bord KPI",
            "acc2Title": "În dezvoltare",
            "devItem1": "Flux de lucru multiagent până la 15 martie 2026: Permite conversații mai orientate spre intenție care nu doar îmbunătățesc relevanța răspunsurilor, ci și execută de la cap la coadă pentru utilizatori.",
            "acc3Title": "În Backlog",
            "backItem1": "Cadru MCP (Backlog): <br /> Oferă o fundație pentru orchestrarea și coordonarea agenților AI în cadrul E.ON, permițând capacități AI la nivel de întreprindere scalabile și colaborative."
        }
    }
}